import { HttpBackend, HttpEvent, HttpEventType, HttpHeaders, HttpRequest, HttpResponse } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { AUTH_COOKIE_SESSION, EnvironmentService } from '@util/environment';
import { defer, Observable, of } from 'rxjs';
import { catchError, filter, map } from 'rxjs/operators';
import { CpUserResponse } from '../../interfaces/user-response.interface';

// eslint-disable-next-line @typescript-eslint/naming-convention
const NATIVE_CLIENT_TYPE_HEADERS: Record<string, string> = { 'X-Client-Type': 'mobile' };
// eslint-disable-next-line @typescript-eslint/naming-convention
const COOKIE_SESSION_CLIENT_TYPE_HEADERS: Record<string, string> = { 'X-Client-Type': 'portal' };

@Injectable({
  providedIn: 'root',
})
export class AuthUsermanagementDataService {
  private readonly http: HttpBackend = inject(HttpBackend);
  private readonly env: EnvironmentService = inject(EnvironmentService);
  private readonly clientTypeHeaders: Record<string, string> = inject(AUTH_COOKIE_SESSION)
    ? COOKIE_SESSION_CLIENT_TYPE_HEADERS
    : NATIVE_CLIENT_TYPE_HEADERS;

  login$(username: string, password: string, token?: string): Observable<CpUserResponse> {
    return this.http
      .handle(
        new HttpRequest(
          'POST',
          `${this.env.environment.api.usermanagement}/login`,
          { username, password, ...(token ? { token } : {}) },
          // eslint-disable-next-line @typescript-eslint/naming-convention
          { headers: new HttpHeaders({ 'Accept-Version': '2', ...this.clientTypeHeaders }) },
        ),
      )
      .pipe(
        filter((event: HttpEvent<CpUserResponse>) => event.type === HttpEventType.Response),
        map((response: HttpEvent<CpUserResponse>) => (response as HttpResponse<CpUserResponse>).body as CpUserResponse),
      );
  }

  refresh$(): Observable<CpUserResponse> {
    return this.http
      .handle(
        new HttpRequest(
          'POST',
          `${this.env.environment.api.usermanagement}/refresh`,
          {},
          { headers: new HttpHeaders(this.clientTypeHeaders) },
        ),
      )
      .pipe(
        filter((event: HttpEvent<CpUserResponse>) => event.type === HttpEventType.Response),
        map((response: HttpEvent<CpUserResponse>) => (response as HttpResponse<CpUserResponse>).body as CpUserResponse),
      );
  }

  logout$(): Observable<void> {
    return defer(() =>
      this.http.handle(new HttpRequest('POST', `${this.env.environment.api.usermanagement}/logout`, {})),
    ).pipe(
      filter((event: HttpEvent<unknown>) => event.type === HttpEventType.Response),
      map((): void => undefined),
      catchError(() => of<void>(undefined)),
    );
  }
}
